<script lang="ts">
  interface Period {
    key: string;
    label: string;
    isLatest?: boolean;
  }

  interface Props {
    periods: Period[];
    value: string;
    onChange: (key: string) => void;
    label?: string;
  }

  let { periods, value, onChange, label = 'Period' }: Props = $props();

  const current = $derived(periods.find((p) => p.key === value));
  const isHistorical = $derived(current && !current.isLatest);
</script>

<div class="period-slicer">
  <span class="lbl">{label}</span>
  <select
    value={value}
    onchange={(e) => onChange((e.currentTarget as HTMLSelectElement).value)}
  >
    {#each periods as p (p.key)}
      <option value={p.key}>{p.label}{p.isLatest ? ' (latest)' : ''}</option>
    {/each}
  </select>
  {#if isHistorical}
    <span class="chip">Historical snapshot</span>
  {/if}
</div>

<style>
  .period-slicer {
    display: inline-flex;
    align-items: center;
    gap: var(--space-sm);
    font-family: var(--font-ui);
    font-size: var(--text-sm);
  }
  .lbl {
    color: var(--color-text-muted);
    font-weight: var(--weight-medium);
  }
  select {
    font-family: var(--font-ui);
    font-size: var(--text-sm);
    color: var(--color-text);
    background: var(--color-white);
    border: 1px solid var(--color-border);
    border-radius: var(--radius-sm);
    padding: 6px 10px;
    cursor: pointer;
    min-width: 160px;
  }
  select:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
    border-color: var(--color-blue);
  }
  .chip {
    background: var(--color-warning-bg);
    color: var(--color-warning);
    font-size: var(--text-xs);
    font-weight: var(--weight-semibold);
    padding: 2px 8px;
    border-radius: var(--radius-full);
  }
</style>
